export const COMPANY_ASSET_TYPE_VALUES = {
    private: {
        company: 'private:company',
        entity: 'private:entity',
        fund: 'private:fund',
        other: 'private:other',
    },
    public: {
        company: 'public:company',
        fund: 'public:fund',
        index: 'public:index',
    },
} as const;

export const COMPANY_ASSET_TYPE_OPTIONS = [
    { group: 'Public', label: 'Companies', value: COMPANY_ASSET_TYPE_VALUES.public.company },
    { group: 'Public', label: 'Funds', value: COMPANY_ASSET_TYPE_VALUES.public.fund },
    { group: 'Public', label: 'Indices', value: COMPANY_ASSET_TYPE_VALUES.public.index },
    { group: 'Private', label: 'Company', value: COMPANY_ASSET_TYPE_VALUES.private.company },
    { group: 'Private', label: 'Fund', value: COMPANY_ASSET_TYPE_VALUES.private.fund },
    { group: 'Private', label: 'Entity', value: COMPANY_ASSET_TYPE_VALUES.private.entity },
    { group: 'Private', label: 'Other', value: COMPANY_ASSET_TYPE_VALUES.private.other },
] as const;

export type CompanyAssetTypeValue = (typeof COMPANY_ASSET_TYPE_OPTIONS)[number]['value'];

export const LEGACY_COMPANY_ASSET_TYPE_ALIASES: Record<string, CompanyAssetTypeValue> = {
    companies: COMPANY_ASSET_TYPE_VALUES.public.company,
    equities: COMPANY_ASSET_TYPE_VALUES.public.company,
    funds: COMPANY_ASSET_TYPE_VALUES.public.fund,
    indices: COMPANY_ASSET_TYPE_VALUES.public.index,
};
